import MarkDown from '@efdigital/ll-addon-content/components/mark-down';
import formatDate, {
  DateFormat,
} from '@efdigital/ll-addon-content/helpers/format-date';
import type { Message } from '@efdigital/ll-addon-data';
import { type TemplateOnlyComponent } from '@ember/component/template-only';

interface Signature {
  Args: {
    messages: Message[];
    category: 'announcement' | 'discussion';
    programId: string;
    cohortId: string;
  };
}

const MessagesList: TemplateOnlyComponent<Signature> = <template>
  {{#if @messages.length}}
    <div class="row g-3">
      {{#each @messages as |message|}}
        <div class="col-12">
          <div class="card">
            <div
              class="card-header d-flex justify-content-between align-items-start"
            >
              <div>
                <h3 class="h5 mb-1">{{message.title}}</h3>
                <div class="text-muted small">
                  <iconify-icon inline icon="ph:user" />
                  {{message.user}}
                  <span class="ms-2">
                    <iconify-icon inline icon="ph:calendar" />
                    {{formatDate message.startDate DateFormat.ShortDate}}
                  </span>
                </div>
              </div>
            </div>
            <div class="card-body">
              <MarkDown @markdown={{message.markdown}} @unsafe={{false}} />
            </div>
          </div>
        </div>
      {{/each}}
    </div>
  {{else}}
    <div class="alert alert-info">
      <iconify-icon inline icon="ph:info" />
      No
      {{@category}}s yet.
    </div>
  {{/if}}
</template>;

export default MessagesList;
